import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es seguro si tengo estrés alto?',
    a: 'Sí, de hecho, el protocolo está diseñado para bajar el cortisol, el principal enemigo de tu energía.'
  }, {
    q: '¿Necesito ir al gimnasio?',
    a: 'No es obligatorio para ver resultados hormonales, aunque se dan recomendaciones de movimiento funcional.'
  }, {
    q: '¿Tengo que dejar de comer lo que me gusta?',
    a: 'No, el enfoque es añadir alimentos clave, no solo restringir.'
  }, {
    q: '¿Funciona si tengo más de 50?',
    a: 'Absolutamente, la optimización es posible a cualquier edad si el sistema sigue activo.'
  }];
  return <section className="bg-navy-900 py-20 px-4 sm:px-6 lg:px-8" data-id="element-9">
      <div className="max-w-3xl mx-auto" data-id="element-10">
        <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-center text-white mb-12" data-id="element-11">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-12">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-13" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`border rounded-lg transition-colors duration-200 ${isOpen ? 'border-gold-500 bg-navy-800' : 'border-navy-700 bg-navy-800/50'}`} data-id="element-14">
      <button className="w-full text-left px-6 py-4 flex items-center justify-between focus:outline-none" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-15">
        <span className={`font-semibold text-lg ${isOpen ? 'text-gold-500' : 'text-white'}`} data-id="element-16">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180 text-gold-500' : 'text-gray-400'}`} data-id="element-17" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-18">
        <p className="px-6 pb-4 text-[#e0e0e0]" data-id="element-19">{answer}</p>
      </div>
    </div>;
}